import defaults from '@mailobj-browser/front/js/selectors/defaults.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import meta from './meta.js'

const { document } = defaults
const { location } = document
const { entries } = Object

const noVoid = ([, value]) => (value ?? null) !== null

export default (
  path,
  params = {}
) => {
  const [service] = meta('service', document)
  const [s] = meta('s', document)
  const { href } = one('base', document) ?? location
  const url = new URL(`/${service}/${path}.php`, href)
  const pairs = entries({ ...params, s }).filter(noVoid)
  
  url.search = `${new URLSearchParams(pairs)}`
  
  return `${url}`
}
